import React from "react";
import "../styles/components/Modal.css";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  component: JSX.Element;
}

class ModalForm extends React.Component<Props> {
  render(): JSX.Element {
    const { isOpen, onClose, component: Component } = this.props;

    if (!isOpen) return <></>;

    return (
      <div
        className="modal-overlay"
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            onClose();
          }
        }}
      >
        <div className="modal-container">
          <div className="modal-content">
            <div className="modal-header">
              <span className="modal-close" onClick={onClose}>
                ×
              </span>
            </div>
            <div className="modal-body">{Component}</div>
          </div>
          <div className="modal-escape-hint">
            <span className="escape-x">×</span>
            <span>(Esc)</span>
          </div>
        </div>
      </div>
    );
  }
}

export default ModalForm;
